import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l-8 4l8 4l8 -4l-8 -4","fill":"currentColor","key":"svg-0"}],["path",{"d":"M10 12l-6 3l8 4l8 -4l-6 -3","key":"svg-1"}]]

/**
 * IconStackForward
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3RhY2stZm9yd2FyZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgNWwtOCA0bDggNGw4IC00bC04IC00IiBmaWxsPSJjdXJyZW50Q29sb3IiIC8+CiAgPHBhdGggZD0iTTEwIDEybC02IDNsOCA0bDggLTRsLTYgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/stack-forward
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStackForward = createReactComponent('outline', 'stack-forward', 'StackForward', __iconNode);

export default IconStackForward;